import { Typography } from 'mobily-ui-library/lib';
import { StringMappingType } from 'typescript';

import './StoreList.scss';

type Props = {
    storeName: any,
    status: string,
    timings: string,
    storeDistance: any;
    rtl: boolean;
    storeId: string;
    handleListClick: any;
    store: any;
}

function StoreList({ store, storeName, status, timings, storeDistance, rtl, storeId, handleListClick }: Props) {
    const color = (status.toLowerCase().replace(/\s/g, '') === 'open') ? '#00bf99' : status.toLowerCase().replace(/\s/g, '') === 'مفتوح' ? '#00bf99' : '#B9BFC6';

    const handleListItem = (el: any) => {
        handleListClick(el.priority)
    }

    return (
        <div className='storeList_container' id={storeId} onClick={() => handleListItem(store)}>
            <Typography rtl={rtl} className='storeName'>{storeName}</Typography>
            <div className={rtl ? 'store_card_arabic store_card' : 'store_card'}>
                <div className='store_status'>
                    <Typography rtl={rtl} className='timings'>{timings}</Typography>
                    <Typography rtl={rtl} className='status' color={color}>{status}</Typography>
                </div>
                <Typography rtl={rtl} className='store_distance'>
                    {storeDistance}
                </Typography>
            </div>
        </div>
    )
}

export default StoreList